export default __webpack_public_path__ + "static/media/primary.96e2f119674ce63f2b213446139a5eb2.svg";